<po-page-list #pageListComponent [p-breadcrumb]="breadcrumb" p-title="Cadastro - Ordem de Produção Outros Estab."
[p-disclaimer-group]="disclaimerGroup"
    [p-actions]="pageActions" [p-filter]="filterSettings" p-subtitle="Consulte os dados cadastrados no sistema.">
    <p class="po-font-subtitle">Verifique todas as Ordens de Produção de Outros Estab. incluídas no sistema.
    </p>
    <po-divider></po-divider>
    <div class="po-row po-mb-4 shadow">
        <div>
            <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
        </div>
        <po-table #dynamicTable p-container="border" [p-actions]="actions" class="po-mr-1 po-ml-1 po-lg-12"
            (p-show-more)="loadMore()"
            [p-show-more-disabled]="!moreItens" p-striped="true" p-text-wrap="false"
            [p-loading-show-more]="!isHideLoading"
            [p-spacing]="poTableColumnSpacing" p-container="border" p-hide-columns-manager="false"
            [p-columns]="columns" [p-items]="tableItens">
            <ng-template p-table-column-template [p-property]="'ordemprod'" let-value>
                <span [innerText]="value" class="po-font-text-large-bold"></span>
            </ng-template>
            <ng-template p-table-column-template [p-property]="'especie'" let-value>
                <span [innerText]="value" class="po-font-text-large-bold"></span>
            </ng-template>
        </po-table>
    </div>
</po-page-list>
<po-modal #advancedFilterModal p-title="Busca avançada" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-combo #poComboCliente
      name="cliente"
      [p-filter-service]="clientServiceApi"
      p-field-value="id"
      p-field-label="razaoSocial"
      (ngModelChange)="chageCliente($event)"
      p-control-value-with-label="true"
      [p-required]="true"
      [p-placeholder]="'Selecione o cliente'"
      p-help="Selecione o cliente para filtrar as ordens de produção de outros estabelecimentos"
      >
    </po-combo>
  </form>
</po-modal>
